import { render } from "./DataProjectBasicInfo.vue?vue&type=template&id=36be0d27&scoped=true"
import script from "./DataProjectBasicInfo.vue?vue&type=script&lang=js"
export * from "./DataProjectBasicInfo.vue?vue&type=script&lang=js"

import "./DataProjectBasicInfo.vue?vue&type=style&index=0&id=36be0d27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36be0d27"]])

export default __exports__